import { authGet, authPost } from '../../utils/authFetch';
import { userServerAddress } from '../../common/MetaSetting';
import { fetchHttpResponseHandler, fetchHttpExceptionHandler } from '../../util/UtilFunction';

function extractArrayData(response: any, apiName: string): any[] {
  if (!response) return [];

  if (Array.isArray(response)) return response;
  if (response.data && Array.isArray(response.data)) return response.data;
  
  const possibleKeys = ['data', 'content', 'list', 'records', 'items', 'friends', 'groups', 'result'];
  for (const key of possibleKeys) {
    if (Array.isArray(response[key])) return response[key];
  }

  console.warn(`${apiName}: 无法从响应中提取数组, keys:`, Object.keys(response));
  return [];
}

export interface JoinGroupRequest {
  groupId: number;
  ownerId?: number;
}

export interface GroupJoinRequestResponse {
  id: string;
  groupId: number;
  applicantUserId: number;
  ownerId?: number;
  status: number;
  createdAt: string;
  updatedAt: string;
}

export function joinGroupRequest(groupId: number, ownerId?: number) {
  return authPost(`${userServerAddress}/group/join-request/${groupId}`, ownerId ? { body: JSON.stringify({ ownerId }) } : undefined)
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}

export function acceptGroupJoinRequest(requestId: string) {
  return authPost(`${userServerAddress}/group/join-request/${requestId}/accept`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}

export function rejectGroupJoinRequest(requestId: string) {
  return authPost(`${userServerAddress}/group/join-request/${requestId}/reject`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}

export function ignoreGroupJoinRequest(requestId: string) {
  return authPost(`${userServerAddress}/group/join-request/${requestId}/ignore`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .catch(fetchHttpExceptionHandler);
}

export function getGroupJoinRequests() {
  return authGet(`${userServerAddress}/group/join-request/pending`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .then((response) => {
      console.info('[getGroupJoinRequests] response:', JSON.stringify(response?.content)?.substring(0, 500));
      const data = extractArrayData(response.content, 'getGroupJoinRequests');
      console.info('[getGroupJoinRequests] extracted data length:', data?.length, 'data:', JSON.stringify(data)?.substring(0, 300));
      return data;
    })
    .catch((error) => {
      console.error('getGroupJoinRequests error:', error);
      return [];
    });
}

export function getMyGroupJoinRequests() {
  return authGet(`${userServerAddress}/group/join-request/my`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .then((response) => {
      const data = extractArrayData(response.content, 'getMyGroupJoinRequests');
      return data;
    })
    .catch((error) => {
      console.error('getMyGroupJoinRequests error:', error);
      return [];
    });
}
